export const SHARE_FAILURE_MESSAGE = 'Couldn’t share. Please try again.';

// Keep native cancellation distinct from failure, and only announce clipboard
// success after the browser has actually accepted the write.
export const shareContent = async ({ url, text, title = 'Podeux' }, { copyOnly = false } = {}) => {
    if (!copyOnly && typeof navigator.share === 'function') {
        try {
            await navigator.share({ title, ...(text ? { text } : {}), url });
            return 'shared';
        } catch (error) {
            if (error?.name === 'AbortError') return 'cancelled';
            throw error;
        }
    }
    if (typeof navigator.clipboard?.writeText !== 'function') {
        throw new Error(SHARE_FAILURE_MESSAGE);
    }
    await navigator.clipboard.writeText(text ? `${text}\n\n${url}` : url);
    return 'copied';
};
